import { isQuotaExceededError } from './StorageManager.ts';

const STATSIG_FAILED_LOGS_PREFIX = 'statsig.failed_logs.';

/**
 * Monkey patch for local storage to catch "Quota Exceeded" errors
 * See https://jira.atlassian.com/browse/CONFDEV-67240.
 */
export const patchLocalStorage = (blockStatsigLocalStorage = false) => {
	const realSetItem = window.localStorage.setItem;

	function newSetItem(this: any, ...args: [string, string]) {
		try {
			const [key] = args;

			// Block statsig.failed_logs.* to prevent unbounded localStorage growth
			// Note this is a temporary fix that will be removed when a fix is deployed in statsig: https://product-fabric.atlassian.net/browse/CCP-7527
			if (blockStatsigLocalStorage && key.startsWith(STATSIG_FAILED_LOGS_PREFIX)) {
				return;
			}

			return realSetItem.apply(this, args);
		} catch (e) {
			if (isQuotaExceededError(e)) {
				window.dispatchEvent(new CustomEvent('local-storage.quota.exceeded'));
			}
			throw e;
		}
	}

	window.localStorage.setItem = newSetItem;
};
